import { t } from '@lingui/macro'
import { NumberSteps, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import { ReactNode } from 'react'

import { useLuneI18nLocale } from '../../hooks'

import StepWithInfoIcon from './StepWithInfoIcon'

export const ExplanationText = ({ text }: { text: string }) => {
    return (
        <Text
            className={'steps_explanation-text'}
            variant={'body2'}
            component={'span'}
            sx={{ whiteSpace: 'nowrap' }}
        >
            {text}
        </Text>
    )
}

export const ExplanationWrapper = ({ children }: { children: ReactNode }) => {
    return (
        <Text
            className={'steps_explanation-wrapper'}
            variant={'body2'}
            component={'span'}
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
            }}
        >
            {children}
        </Text>
    )
}

export type ExplanationStep = {
    description?: JSX.Element
    info?: string | JSX.Element | null
    /**
     * The icon to display for this step.
     * - `undefined` (default): Shows numbered circle for main explanation steps
     * - `'intelligence'`: Shows intelligence icon for inferred data
     * - `'none'`: Shows just connecting line for additional data
     */
    stepIcon?: 'intelligence' | 'none' | undefined
}

export const ExplanationSteps = ({
    steps,
    pdfStructure,
    smallTitle,
}: {
    steps: ExplanationStep[]
    pdfStructure?: boolean
    smallTitle?: boolean
}) => {
    useLuneI18nLocale()

    return (
        <>
            {!!steps.length && (
                <Box>
                    <Text variant={smallTitle ? 'body2-medium' : 'h6'} sx={{ mb: 4 }}>
                        {t`How we calculated these emissions`}
                    </Text>
                    <Box data-testid={`calculation-steps-wrapper`} sx={{ overflowX: 'auto' }}>
                        <NumberSteps
                            steps={steps.map(({ description, info, stepIcon }, index) => {
                                return {
                                    stepIcon,
                                    component: (
                                        <StepWithInfoIcon
                                            index={index}
                                            key={index}
                                            step={{ description }}
                                            info={pdfStructure ? null : (info ?? null)}
                                        />
                                    ),
                                }
                            })}
                        />
                    </Box>
                </Box>
            )}
        </>
    )
}

export default ExplanationSteps
